import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cec856ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0 py-9"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Statistik", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Statistik", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 form-button" }, [
    /*#__PURE__*/_createElementVNode("button", {
      id: "submit-button-forecast",
      type: "submit",
      class: "button button-primary adjust-button-size"
    }, " Opdater ")
  ])
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "table--responsive-scroll" }
const _hoisted_7 = {
  class: "table table--selectable",
  id: "selectable-table1"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, "statistik", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Navn"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Beskrivelse"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Værdi")
  ])
], -1))
const _hoisted_10 = {
  key: 1,
  class: "container px-0 py-9"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.pageAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.getStatistics()), ["prevent"]))
        }, [
          _createElementVNode("fieldset", null, [
            _hoisted_3,
            _hoisted_4,
            (_ctx.recalculateErrors.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.recalculateErrors), 1))
              : _createCommentVNode("", true)
          ])
        ], 32),
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statistics, (stat) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: stat.name
                  }, [
                    _createElementVNode("td", null, _toDisplayString(stat.name), 1),
                    _createElementVNode("td", null, _toDisplayString(stat.description), 1),
                    _createElementVNode("td", null, _toDisplayString(stat.value), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, "Din brugerprofil har ikke adgang til dette skærmbillede"))
}